import axios, { HttpStatusCode } from "axios";

const axiosHttp = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

// Request Interceptor (Optional)
axiosHttp.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token") || "";
    if (token) {
      // config.headers.Authorization = `Bearer ${token}`;
      config.headers["x-access-token"] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject({
      message: "Request error occurred",
      status: HttpStatusCode.InternalServerError,
      ...(error?.request || {}),
    });
  }
);

// Response Interceptor
axiosHttp.interceptors.response.use(
  (response) => {
    if (response.status >= HttpStatusCode.Ok && response.status <= 299) {
      return (
        response.data || {
          error: false,
          data: [],
          message: "",
        }
      );
    } else {
      const errorData = response?.data || {
        error: true,
        status: response.status,
        data: [],
        message: "API error occurred",
      };
      return Promise.reject(errorData);
    }
  },
  (error) => {
    return Promise.reject({
      message: "Response error occurred",
      status: HttpStatusCode.InternalServerError,
      ...(error?.response || {}),
    });
  }
);

export default axiosHttp;
